import React from "react";
import "./styles.scss";
import SoundTrackIcon from "../../../../../shared/Svg/MusicUploaderIcon";
import VideoIcon from "../../../../../shared/Svg/VideoUploaderIcon";
import ImageIcon from "../../../../../shared/Svg/ImgUploaderIcon";
import { ReactComponent as RemoveIcon } from "../../../../../../public/icons/remove-button.svg";

interface Props {
  attachments?: any;
  onRemoveAttachment: any;
}

export default (props: Props) => {
  const renderPreview = (attachment: any) => {
    const removeAttachment = () => props.onRemoveAttachment(attachment);
    switch (attachment.type) {
      case "SoundTrack":
        return (
          <div className="card SoundTrack-tag">
            <RemoveIcon onClick={removeAttachment} className="remove-button" />
            <SoundTrackIcon
              className="type-icon"
              color="#dadada"
              opacity={"1.0"}
            />
          </div>
        );
      case "Image":
        return (
          <div className="card image-tag">
            <RemoveIcon onClick={removeAttachment} className="remove-button" />
            <ImageIcon className="type-icon" color="#dadada" opacity={"1.0"} />
          </div>
        );
      case "Video":
        return (
          <div className="card video-tag">
            <RemoveIcon onClick={removeAttachment} className="remove-button" />
            <VideoIcon className="type-icon" color="#dadada" opacity={"1.0"} />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="comments-attachments mx-4 mt-4">
      {props.attachments?.map((a: any) => renderPreview(a))}
    </div>
  );
};
